export const API_ENDPOINTS = {
  USERS_LOGIN: "/extract",
};
